import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { InputBase, InputAdornment } from '@material-ui/core'
import { useRouter } from 'next/router'
import URI from 'urijs'

import { mobileSize } from 'theme'
import { hidden, inputSearchCancelButtonStyle } from './mixin'
import icSearchSrc from '/static/images/ic-search.png'
import { useTrackingStore } from 'store/trackingStore'
import { BUTTON_NAME, EVENT_ACTION, COUPON_SCREEN_NAME } from 'tracking'

const SearchInput = () => {
  const router = useRouter()
  const [searchValue, setSearchValue] = useState('')
  const [hiddenResult, setHiddenResult] = useState(true)
  // eslint-disable-next-line no-unused-vars
  const [searchResults, setSearchResults] = useState([])
  const { trackEvent } = useTrackingStore()

  const handleChange = useCallback((e) => {
    setSearchValue(e.target.value)
  }, [])

  const trackSearch = useCallback(
    (isSearchingSku) =>
      trackEvent(EVENT_ACTION.CLICK, {
        button: BUTTON_NAME.SEARCH,
        search_text: searchValue,
        screen: isSearchingSku
          ? COUPON_SCREEN_NAME.MYCOUPON
          : COUPON_SCREEN_NAME.SKUS,
      }),
    [searchValue, trackEvent]
  )

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        // TODO: call search api
        const isSearchingSku = router.pathname !== '/skus'
        trackSearch(isSearchingSku)
        if (isSearchingSku) {
          router.push(`/skus?searchKey=${searchValue}`)
        } else {
          const newUrl = URI(router.asPath)
            .search({ searchKey: searchValue })
            .toString()
          router.replace(newUrl)
        }
        setHiddenResult(true)
      }
    },
    [router, searchValue, trackSearch]
  )

  return (
    <SearchInputWrapper>
      <StyledInput
        onKeyDown={handleEnter}
        onChange={handleChange}
        onBlur={useCallback(() => {
          setHiddenResult(true)
        }, [])}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        placeholder="搜尋優惠券"
        type="search"
      />
      <SearchResultsWrapper hidden={hiddenResult}>
        <SearchResultsList>
          {searchResults.map((result, i) => (
            <ResultItem key={i}>{result}</ResultItem>
          ))}
        </SearchResultsList>
        <StyledResult>{searchResults.length}个结果</StyledResult>
      </SearchResultsWrapper>
    </SearchInputWrapper>
  )
}

export const SearchIcon = () => <img src={icSearchSrc} />

const SearchInputWrapper = styled.div`
  position: relative;
  @media ${mobileSize} {
    ${hidden};
  }
`

const StyledInput = styled(InputBase)`
  padding: 0 16px;
  border-radius: 4px;
  border: solid 1px ${(p) => p.theme.color.grey80};

  input {
    width: 144px;
    padding: 5px 0 6px;
    transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    &:focus {
      width: 264px;
      transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  }

  @media (max-width: 640px) {
    input {
      &:focus {
        width: 228px;
        transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      }
    }
  }

  ${inputSearchCancelButtonStyle};
`

const SearchResultsWrapper = styled.div`
  border-radius: 4px;
  border: solid 1px ${(p) => p.theme.color.grey80};
  background-color: ${(p) => p.theme.color.white};
  padding: 8px 16px;
  position: absolute;
  top: 40px;
  right: 0;
  display: flex;
  width: 320px;
  box-sizing: border-box;
  font-size: 14px;
  color: ${(p) => p.theme.color.dark200};

  ${(p) => p.hidden && hidden}
`

const SearchResultsList = styled.div`
  width: 70%;
`

const ResultItem = styled.div`
  padding: 5px 0;
  margin: 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
`

const StyledResult = styled.div`
  width: 30%;
  text-align: right;
  padding: 10px 0;
`

export default SearchInput
